import React, { useEffect, useState } from 'react';
import Select from 'v3/components/Select';
import { Button, Text, Input } from 'v3/components';
import useQuery from 'hooks/useQuery';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Actions, Container, Field, SecondaryAction } from './styles';

import {
  fetchSingleChecklistStatus
} from 'utils/fetches';

export default function SingleChecklistResponseFilter({
  loading,
  onChange,
  setAdvancedFilters,
  advancedFilters,
  rightAction,
}) {
  const query = useQuery();
  const navigate = useNavigate();
  const location = useLocation();

  const [statusOptions, setStatusOptions] = useState([]);

  const selectedStatusId = advancedFilters?.status
    ? (typeof advancedFilters.status === 'object' ? advancedFilters.status?.id : advancedFilters.status)
    : null;

  const selectedStatus = selectedStatusId
    ? statusOptions.find(option => Number(option?.id) === Number(selectedStatusId))
      || (typeof advancedFilters?.status === 'object' ? advancedFilters.status : null)
    : null;

  function updateSearchParams(callback) {
    const nextQuery = new URLSearchParams(location.search);
    callback(nextQuery);
    navigate({ search: nextQuery.toString() }, { replace: true });
  }

  useEffect(() => {
    fetchSingleChecklistStatus().then(setStatusOptions);
  }, []);

  return (
    <Container>

      <Field minWidth="200px">
        <Input
          type="date"
          label="Data de início"
          labelColor="#fff"
          value={advancedFilters?.start_date || query.get('start_date')}
          onChange={event => {
            const value = event.target?.value;
            setAdvancedFilters(old => ({ ...old, start_date: value || null }));
            updateSearchParams(nextQuery => {
              if (!value) {
                nextQuery.delete('start_date');
              } else {
                nextQuery.set('start_date', moment(value).format('YYYY-MM-DD'));
              }
            });
          }}
        />
      </Field>

      <Field minWidth="200px">
        <Input
          type="date"
          label="Data de término"
          labelColor="#fff"
          value={advancedFilters?.end_date || query.get('end_date')}
          onChange={event => {
            const value = event.target?.value;
            setAdvancedFilters(old => ({ ...old, end_date: value || null }));
            updateSearchParams(nextQuery => {
              if (!value) {
                nextQuery.delete('end_date');
              } else {
                nextQuery.set('end_date', moment(value).format('YYYY-MM-DD'));
              }
            });
          }}
        />
      </Field>
      <Field minWidth="300px">
        <Select
          label="Status"
          options={statusOptions}
          horizontal
          labelTextColor='white'
          modalHeading="Selecione um status"
          modalBodyTitle="Status:"
          placeholder="Selecione..."
          getOptionLabel={option => `${option?.name}`}
          getOptionValue={option => option?.id}
          value={selectedStatus}
          onChange={value => {
            const statusValue = typeof value === 'object' ? value?.id : value;

            updateSearchParams(nextQuery => {
              if (statusValue) {
                nextQuery.set('status', String(statusValue));
              } else {
                nextQuery.delete('status');
              }
            });

            setAdvancedFilters(old => ({
              ...old,
              status: statusValue ? (typeof value === 'object' ? value : { id: Number(statusValue) }) : null,
            }));
          }}
        />
      </Field>
      <Actions>
        <Button variant="primary" loading={loading} onClick={() => onChange(advancedFilters)}>
          <Text color="white" weight={500}>Filtrar</Text>
        </Button>
      </Actions>
      {rightAction ? (
        <SecondaryAction>
          {rightAction}
        </SecondaryAction>
      ) : null}
    </Container>
  );
}
